// extracted by mini-css-extract-plugin
export default {"modal":"upload_cv_modal-module___modal___bd62cd87"};